import { List, fromJS } from 'immutable';

import { getFiltersFromUrl } from '../../../utils';
import * as filtersContoller from '../../../data/controllers/FilterController';
import * as filterConstants from './constants';

const changeFilter = (state, { path, diff }) => {
  const filter = state.get(path);

  if (List.isList(filter)) {
    return state.update(path, (items) =>
      items.map((item) => {
        const diffForItem = Array.isArray(diff)
          ? diff.find((newItem) => newItem.id === item.get('id'))
          : diff.id === item.get('id') && diff;

        return diffForItem ? item.merge(diffForItem) : item;
      }),
    );
  }

  return state.set(path, filter.merge(diff));
};

export const prepareFilters = () => {
  const {
    filter_hotel_name: hotelName = '',
    filter_price_min: minPrice,
    filter_price_max: maxPrice,
  } = getFiltersFromUrl();
  const prices = {
    segments: [],
    minPrice: +minPrice || null,
    maxPrice: +maxPrice || null,
  };
  return fromJS({
    prices,
    hotel_name: { value: String(hotelName).replace(/\+/g, ' ') },
  });
};

export default function filterReducer(state = prepareFilters(), action) {
  switch (action.type) {
    case filterConstants.CHANGE_FILTER:
      return changeFilter(state, action.payload);

    case filterConstants.CLEAR_FILTER: {
      const path = action.payload;
      const diff = filtersContoller.clearFilter(path, state.get(path));
      return changeFilter(state, { diff, path });
    }

    case filterConstants.CLEAR_FILTERS: {
      let newState = state;

      const filtersList = state.keySeq().toArray();

      filtersList.forEach((path) => {
        const filterData = state.get(path);
        if (filterData) {
          const diff = filtersContoller.clearFilter(path, filterData);
          newState = changeFilter(newState, { diff, path });
        }
      });
      return newState;
    }

    case filterConstants.SET_PREVIOUS_FILTERS: {
      const previousFilters = action.payload;
      return state.mergeDeep(previousFilters);
    }

    case filterConstants.SET_FILTERS:
      return action.payload;

    case filterConstants.FILTRATION_SUCCESS:
      return prepareFilters().mergeDeep({ ...action.payload.filters });

    default:
      return state;
  }
}
